/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type InvitationDetailResponseRole = typeof InvitationDetailResponseRole[keyof typeof InvitationDetailResponseRole];


export const InvitationDetailResponseRole = {
  admin: 'admin',
  member: 'member',
} as const;
